export const PATHS_MAP = {
  '/families': {
    role: 'client',
    title: 'Семья'
  }
};
